import { Model } from 'modules/core/lib/mobx-rest'

interface ITimeOption {
  id: string
  label: string
}

interface IAttribute {
  id: string
  label: string
  subcategory: string
  time_units: ITimeOption[]
}

interface ITimeOption {
  id: string
  label: string
  attributes: IAttribute[]
}

export class TimeOption extends Model<ITimeOption> {
  static urlRoot() {
    return '/automations/time_options'
  }
}
